import { InjectionToken } from '@angular/core';

export const WindowToken = new InjectionToken('Window');
export const windowProvider = (): Window => window;
